import { Component, OnInit, Input, EventEmitter, Output, ContentChildren, QueryList, AfterViewInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { InputDataOptionComponent, InputDataOption } from './input-data-option/input-data-option.component';

@Component({
    selector: 'input-data-list',
    templateUrl: 'input-data-list.component.html',
    styleUrls: ['input-data-list.component.scss']
})

export class InputDataListComponent {
    @ViewChild("input", { static: true }) input: ElementRef;
    @ViewChild("dataList", { static: true }) dataList: ElementRef;

    @ContentChildren(InputDataOptionComponent, { descendants: true }) inputDataOptions: QueryList<InputDataOptionComponent>

    @HostListener('window:resize', ['$event'])
    onResize() {
        (<HTMLDivElement>this.dataList.nativeElement).style.width = (<HTMLDivElement>this.input.nativeElement).offsetWidth + "px";
    }

    @Input()
    labelName: string;

    @Input()
    selectedItem: InputDataOption;

    @Input()
    textToSearch: string = "";

    dataItems: InputDataOption[] = new Array<InputDataOption>();

    filteredDataItems: InputDataOption[] = new Array<InputDataOption>();

    @Output()
    selectedItemChanged = new EventEmitter<InputDataOption>();

    onFocus: boolean = false;

    blurByClick: boolean = false;

    setItemTimeOut: any;

    lastActivedItem: InputDataOption;

    constructor() { }

    ngAfterContentInit() {
        let options = this.inputDataOptions.toArray();
        for (let option in options) {
            let inputDataOption = new InputDataOption();

            inputDataOption.id = options[option].id;
            inputDataOption.description = options[option].description;

            this.dataItems.push(inputDataOption);
        }
        this.textChanged();
    }

    textChanged() {
        if (this.textToSearch == null || this.textToSearch.length == 0) {
            this.filteredDataItems = this.dataItems;
        }

        this.filteredDataItems = this.dataItems.filter(x =>
            x.description.toLowerCase().indexOf(this.textToSearch.toLowerCase()) > -1);

        if (this.filteredDataItems.length == 0) {
            this.lastActivedItem = null;
        } else {
            this.lastActivedItem = this.filteredDataItems[0];
        }
    }

    itemClicked() {
        if (!this.lastActivedItem)
            return;

        this.textToSearch = this.lastActivedItem.description;
        this.textChanged();
        this.selectedItemChanged.next(this.lastActivedItem);
    }

    onBlur() {
        if (this.filteredDataItems.length > 0) {
            if (this.lastActivedItem != null) {
                this.itemClicked()
            }
        } else {
            this.textToSearch = "";
            this.filteredDataItems = this.dataItems;
            this.selectedItemChanged.next(null);
        }
        this.onFocus = false;
    }

    mouseOverOption(option: InputDataOption) {
        this.lastActivedItem = option;
    }
}